// general -------------------------------------------------------------------------------------------------------------
import UserAccount from './user-account'

// Otp -----------------------------------------------------------------------------------------------------------------
import Otp from './otp'

// order ---------------------------------------------------------------------------------------------------------------
import Order from './order/order'
import OrderPoint from './order/order-point'
import OrderPrice from './order/order-price'
import CreateOrder from './order/create-order'
import TemporaryOrder from './order/temporary-order'

// billOfLading -----------------------------------------------------------------------------------------------------------
import BillOfLading from './bill-of-lading'

// TODO: remove after migration
import OrderSupported from './order/order-supported'
import OrderOffer from './order/order-offer'
import OrderCar from './order/order-car'
import OrderTemplate from './order/order-template'
import OrderDraft from './order/order-draft'
import OrderBatch from './order/order-batch'
import OrderBatchItem from './order/order-batch-item'

// supported -----------------------------------------------------------------------------------------------------------
import SupportedOrder from './supported/order'

// reports -------------------------------------------------------------------------------------------------------------
import ReportsStatistics from '@/api/reports/reports-statistics'
import ReportsStatistical from '@/api/reports/reports-statistical'
import ReportsDictionaryConflict from '@/api/reports/reports-dictionary-conflict'
import UndefinedFurnitureCarTariff from '@/api/reports/undefinedTariff/furniture/car'
import UndefinedFurnitureEmployeeTariff from '@/api/reports/undefinedTariff/furniture/employee'
import UndefinedFurnitureTariff from '@/api/reports/undefinedTariff/furniture/furniture'
import UndefinedFurnitureItemTariff from '@/api/reports/undefinedTariff/furniture/item'
import UndefinedFurnitureTrafficPlanTariff from '@/api/reports/undefinedTariff/furniture/traffic-plan'
import UndefinedTrashTariff from '@/api/reports/undefinedTariff/trash/trash'
import UndefinedTrashCarTariff from '@/api/reports/undefinedTariff/trash/car'
import UndefinedMaterialTariff from '@/api/reports/undefinedTariff/material'
import UndefinedAuctionTariff from '@/api/reports/undefinedTariff/auction'
import ReportsSettlementDriver from '@/api/reports/driver-settlement'

// feedback ------------------------------------------------------------------------------------------------------------
import Feedback from '@/api/feedback'

// crm -----------------------------------------------------------------------------------------------------------------
import CrmFaq from '@/api/crm/crm-faq'
import CrmContact from '@/api/crm/crm-contact'
import CrmTicket from '@/api/crm/crm-ticket'
import CrmTicketMessage from '@/api/crm/crm-ticket-message'
import CrmTutorial from '@/api/crm/crm-tutorial'

// financial -----------------------------------------------------------------------------------------------------------
// bonus
import FinancialBonusCouponType from '@/api/financial/bonus/financial-bonus-coupon-type'
import FinancialBonusGiftCardType from '@/api/financial/bonus/financial-bonus-gift-card-type'
import FinancialBonusCoupon from '@/api/financial/bonus/financial-bonus-coupon'
import FinancialBonusGiftCard from '@/api/financial/bonus/financial-bonus-gift-card'
import FinancialBonusCampaign from '@/api/financial/bonus/financial-bonus-campaign'
import FinancialBonusPromotion from '@/api/financial/bonus/financial-bonus-promotion'

// payment
import FinancialPayment from './financial/financial-payment'
import FinancialOpenBankingPayment from './financial/financial-open-banking-payment'

// tariff
import FurnitureTariff from './financial/tariff/furniture/furniture-tariff.js'
import FurnitureCarTariff from './financial/tariff/furniture/car-tariff.js'
import FurnitureEmployeeTariff from './financial/tariff/furniture/employee-tariff.js'
import FurnitureItemTariff from './financial/tariff/furniture/item-tariff.js'
import FurnitureTrafficPlanTariff from './financial/tariff/furniture/traffic-plan-tariff.js'

import FinancialTariffCar from './financial/tariff/financial-tariff-car'
import FinancialTariffTrafficPlan from './financial/tariff/financial-tariff-traffic-plan'
import FinancialTariffEmployee from './financial/tariff/financial-tariff-employee'
import FinancialTariffItem from './financial/tariff/financial-tariff-item'
import FinancialTariffExtra from './financial/tariff/financial-tariff-extra'
import FinancialTariffAuction from './financial/tariff/financial-tariff-auction'
import FinancialTariffMaterial from './financial/tariff/financial-tariff-material'
import FinancialTariffTrash from './financial/tariff/financial-tariff-trash'
import FinancialTariffTrashCar from './financial/tariff/financial-tariff-trash-car'

// bank-account
import FinancialBankAccount from './financial/financial-bank-account'

// commercial-banking
import FinancialCommercialBanking from './financial/financial-commercial-banking'

// commercial-banking
import FinancialTransactionCredit from './financial/financial-transaction-credit'

// courier -------------------------------------------------------------------------------------------------------------
import Courier from './courier/courier'
import CourierOperator from './courier/courier-operator'
import CourierHolding from './courier/courier-holding'
import CourierLicense from './courier/courier-license'
import Branch from './branch/branch'
import CourierBlackList from './courier/black-list'
import CourierContract from './courier/courier-contract'
import CourierShift from './courier/shift'

// user ----------------------------------------------------------------------------------------------------------------
import AdminUser from './user/admin'
import CustomerUser from './user/customer'
import UserSession from './user/user-session'
import UserAddress from './user/user-address'
import UserContract from './user/user-contract'
import UserLegal from './user/user-legal'

// transport -----------------------------------------------------------------------------------------------------------
import TransportDriver from './transport/transport-driver'
import TransportVehicle from './transport/transport-vehicle'
import TransportCredential from './transport/credential'
import TransportDriverBlackList from './transport/black-list'

// base-info -----------------------------------------------------------------------------------------------------------
// car
import BaseInfoCarCategory from './base-info/car/base-info-car-category'
import BaseInfoCarType from './base-info/car/base-info-car-type'
import BaseInfoCarLoad from './base-info/car/base-info-car-load'
import BaseInfoCarBrand from './base-info/car/base-info-car-brand'

// order-properties
import BaseInfoOrderPropertiesEmployee from './base-info/order-properties/base-info-order-properties-employee'
import BaseInfoOrderPropertiesItemGroup from './base-info/order-properties/base-info-order-properties-item-group'
import BaseInfoOrderPropertiesItemCategory from './base-info/order-properties/base-info-order-properties-item-category'
import BaseInfoOrderPropertiesItemType from './base-info/order-properties/base-info-order-properties-item-type'
import BaseInfoOrderPropertiesLoad from './base-info/order-properties/base-info-order-properties-load'
import BaseInfoOrderPropertiesPackageType from './base-info/order-properties/base-info-order-properties-package-type'
import BaseInfoOrderPropertiesPackage from './base-info/order-properties/base-info-order-properties-package'
import BaseInfoOrderPropertiesSoil from './base-info/order-properties/base-info-order-properties-soil'
import BaseInfoOrderPropertiesAddon from './base-info/order-properties/base-info-properties-addon'
import BaseInfoOrderPropertiesLoadCondition from './base-info/order-properties/base-info-properties-load-condition'

// reason
import BaseInfoReason from './base-info/base-info-reason'

// organization
import BaseInfoOrganization from './base-info/base-info-organization'

// feedback
import BaseInfoFeedbackRateCriterion from './base-info/base-info-feedback-rate-criterion'
import BaseInfoFeedbackPointCriterion from './base-info/base-info-feedback-point-criterion'

// club
import BaseInfoClubReferrerType from './base-info/base-info-club-referrer-type'

// crm
import BaseInfoCrmFaqCategory from './base-info/crm/base-info-crm-faq-category'
import BaseInfoCrmDepartment from './base-info/crm/base-info-crm-department'
import BaseInfoCrmMedia from './base-info/crm/base-info-crm-media'
import BaseInfoCrmCategory from './base-info/crm/base-info-crm-category'
import BaseInfoCrmSubcategory from './base-info/crm/base-info-crm-subcategory'
import BaseInfoCrmSubject from './base-info/crm/base-info-crm-subject'

// financial
import BaseInfoFinancialBank from './base-info/financial/base-info-financial-bank'
import BaseInfoFinancialPolicy from './base-info/financial/base-info-financial-policy'

// courier
import BaseInfoCourierExpertise from './base-info/courier/base-info-courier-expertise'
import BaseInfoCourierEquipment from './base-info/courier/base-info-courier-equipment'

// user
import BaseInfoUserLicenseType from './base-info/user/base-info-user-license-type'
import BaseInfoUserGroup from './base-info/user/base-info-user-group'
import BaseInfoUserLevel from './base-info/user/base-info-user-level'

// contract
import BaseInfoContractCategory from './base-info/base-info-contract-category'

// cms
import BaseInfoCmsThemeCategory from './base-info/base-info-cms-theme-category'

// questionnaire
import BaseInfoQuestionnaireQuestionCategory from './base-info/base-info-questionnaire-question-category'

// geo
import BaseInfoGeoCountry from './base-info/geo/base-info-geo-country'
import BaseInfoGeoProvince from './base-info/geo/base-info-geo-province'
import BaseInfoGeoCounty from './base-info/geo/base-info-geo-county'
import BaseInfoGeoCity from './base-info/geo/base-info-geo-city'
import BaseInfoGeoDistrict from './base-info/geo/base-info-geo-district'
import BaseInfoGeoTrafficPlan from './base-info/geo/base-info-geo-traffic-plan'

// poi
import BaseInfoPoi from './base-info/poi/base-info-poi'
import BaseInfoPoiCategory from './base-info/poi/base-info-poi-category'

// unit
import BaseInfoUnitCurrency from './base-info/unit/base-info-unit-currency'
import BaseInfoUnitMeasurement from './base-info/unit/base-info-unit-measurement'

// feature
import BaseInfoFeatureSize from './base-info/feature/base-info-feature-size'
import BaseInfoFeatureColor from './base-info/feature/base-info-feature-color'

// calendar
import BaseInfoCalendarHoliday from './base-info/base-info-calendar-holiday'

// ---------------------------------------------------------------------------------------------------------------------
import Files from './files'
import ManageDriver from './manageDriver'
import Geo from './geo'
import PublicGeo from './public-geo'
import CalendarTraffic from './calendarTraffic'

import Log from './log'

//security
import Licenses from '@/api/security/license'
import Realms from '@/api/security/realms'
import Roles from '@/api/security/roles'
import SecurityPermissions from '@/api/security/securityPermissions'
import Limit from './security/limit'
import LimitLicense from './security/limit-license'

// system
import SystemConfig from '@/api/system/system-config'
import SystemGatewayOrder from '@/api/system/system-gateway-order'
import SystemDictionary from '@/api/system/system-dictionary'
import SystemDictionaryMiss from '@/api/system/system-dictionary-miss'
import AppVersion from '@/api/system/appVersion'
import WebView from '@/api/system/webView'
import WebService from '@/api/system/webService'
import FileManager from '@/api/system/file-manager'
import Attachment from '@/api/system/attachment/attachment'
import Bucket from '@/api/system/attachment/bucket'
import Container from '@/api/system/attachment/container'
import UrlShortened from '@/api/system/urlShortened'
import OperationParameter from '@/api/system/operation-parameter'
import CodeGenerator from '@/api/system/code-generator'
import GatewayEmail from '@/api/system/gateway-email'
import GatewayNotification from '@/api/system/gateway-notification'
import GatewaySms from '@/api/system/gateway-sms'
import GatewayPayment from '@/api/system/gateway-payment'
import GatewayOpenBanking from '@/api/system/gateway-open-banking'
import SystemSettingGeneral from '@/api/system/system-setting-general'
import SystemSettingMap from './system/system-setting-map'

//message
import MessageSms from '@/api/message/message-sms'
import MessageEmail from '@/api/message/message-email'
import MessageInternal from '@/api/message/message-internal'
import MessageInternalTemplate from '@/api/message/message-internal-template'
import MessageSentSms from '@/api/message/message-sent-sms'
import MessageSentEmail from '@/api/message/message-sent-email'
import MessageSentNotification from '@/api/message/message-sent-notification'
import {
  MessageNotification,
  PublicMessageNotification
} from '@/api/message/message-notification'

import Event from '@/api/message/event'

// cms
import CmsSplash from '@/api/cms/cms-splash'
import CmsArea from '@/api/cms/cms-area'
import CmsLanding from '@/api/cms/cms-landing'
import CmsTheme from './cms/cms-theme'
import CmsLayout from '@/api/cms/cms-layout'
import CmsPage from '@/api/cms/cms-page'
import CmsFileManager from '@/api/cms/file-manager'

//blog
import BlogPost from '@/api/blog/post'
import BlogComment from '@/api/blog/comment'
import PostCategory from '@/api/blog/post-category'
import BlogFileManager from '@/api/blog/file-manager'
import BlogTag from '@/api/blog/tag'
import BlogArea from '@/api/blog/area'
import BlogPage from '@/api/blog/page'

//timesheet
import TimeSheetTrafficPlanTemplate from '@/api/time-sheet/time-sheet-traffic-plan-template'
import TimeSheetCourierPlanTemplate from '@/api/time-sheet/time-sheet-courier-plan-template'

// geo-location
import GeoControll from './geo-location/geoControll'

// tariff
import TariffTrafficPlanLog from '@/api/tariff/trafficPlan/tariffTrafficPlanLog'
import TariffAuctionLog from '@/api/tariff/auction/tariffAuctionLog'
import TariffItemLog from '@/api/tariff/item/tariffItemLog'
import TariffCarLog from '@/api/tariff/car/tariffCarLog'
import TariffEmployeeLog from '@/api/tariff/employee/tariffEmployeeLog'
import TariffExtraLog from '@/api/tariff/extra/tariffExtraLog'

// menu
import Menus from '@/api/menu/menus'

// account
import PublicUser from '@/api/account/publicUser'

// logs
import Logs from '@/api/log/logs'

// bulk-upload
import BulkUpload from '@/api/bulkUpload/bulk-upload'

//site
import Site from '@/api/site/site'
import SitePage from '@/api/site/site-page'
import SiteArea from '@/api/site/site-area'
import SiteContact from '@/api/site/site-contact'
import SiteFaq from '@/api/site/site-faq'
import SiteFaqCategory from '@/api/site/site-faq-category'
import SiteLayout from '@/api/site/site-layout'
import SiteTemplate from '@/api/site/template'
import SiteThemeCategory from './site/theme-category'
import SiteTheme from '@/api/site/theme'
import SitePostCategory from '@/api/site/post-category'
import SiteLanding from '@/api/site/site-landing'
import SiteSplash from '@/api/site/splash'
import SiteFileManager from './site/file-manager'

//questionnaire
import Question from './questionnaire/question'
import Answer from './questionnaire/answer'
import Servey from './questionnaire/survey'

// operation
import Operation from './operation'

// time-sheet
import CourierTimeSheet from './courier-time-sheet'

// Enum
import Enum from './enum/index.js'

import Setting from './setting'

// base-info -----------------------------------------------------------------------------------------------------------
import TransactionOrder from './transaction/order'

// Record -----------------------------------------------------------------------------------------------------------
import RecordFurnitureFurnitureTariff from './record/tariff/furniture/furniture-tariff'
import RecordFurnitureCar from './record/tariff/furniture/car'
import RecordFurnitureEmployee from './record/tariff/furniture/employee'
import RecordFurnitureItem from './record/tariff/furniture/item'
import RecordFurnitureTrafficPlan from './record/tariff/furniture/trafficPlan'
import RecordTrashTariff from './record/tariff/trash/trash-tariff'
import RecordTrashCar from './record/tariff/trash/car'
import RecordTransportVehicle from './record/transport/vehicle'
import RecordTransportDriver from './record/transport/driver'
import RecordUserContract from './record/user/contract'
// Supported -----------------------------------------------------------------------------------------------------------
import SupportedCar from './supported/car'
import SupportedEmployee from './supported/employee'
import SupportedItem from './supported/item'

// external apis
import Neshan from './neshan'

// External system
import Baraneh from './external/baraneh'
import BaseInfoCourierLicenseType from './base-info/courier/base-info-courier-license-type'
import BaseInfoCourierLicenseCategory from './base-info/courier/base-info-courier-license-category'
import FinancialTariffFreight from './financial/tariff/financial-tariff-freight'
import FinancialTariffFreightAddon from './financial/tariff/financial-tariff-freight-addon'
import FinancialTariffFurnitureAddon from './financial/tariff/furniture/furniture-tariff-addon'
import FinancialTariffFreightCar from './financial/tariff/financial-tariff-freight-car'
import BaseInfoCrmContactSubject from './base-info/crm/base-info-crm-contact-subject'

export default (store) => ({
  // general -----------------------------------------------------------------------------------------------------------
  userAccount: new UserAccount(store),

  // Otp
  otp: new Otp(store),

  // order -------------------------------------------------------------------------------------------------------------
  order: new Order(store),
  orderPrice: new OrderPrice(store),
  orderPoint: new OrderPoint(store),
  createOrder: new CreateOrder(store),
  temporaryOrder: new TemporaryOrder(store),
  // TODO: remove after migration
  orderSupported: new OrderSupported(store),
  orderOffer: new OrderOffer(store),
  orderCar: new OrderCar(store),
  orderTemplate: new OrderTemplate(store),
  orderDraft: new OrderDraft(store),
  orderBatch: new OrderBatch(store),
  orderBatchItem: new OrderBatchItem(store),

  // billOfLading -----------------------------------------------------------------------------------------------------------
  billOfLading: new BillOfLading(store),

  // supported ---------------------------------------------------------------------------------------------------------
  supportedOrder: new SupportedOrder(store),

  // reports -----------------------------------------------------------------------------------------------------------
  reportsStatistics: new ReportsStatistics(store),
  reportsStatistical: new ReportsStatistical(store),
  reportsDictionaryConflict: new ReportsDictionaryConflict(store),
  undefinedFurnitureCarTariff: new UndefinedFurnitureCarTariff(store),
  undefinedFurnitureEmployeeTariff: new UndefinedFurnitureEmployeeTariff(store),
  undefinedFurnitureTariff: new UndefinedFurnitureTariff(store),
  undefinedFurnitureItemTariff: new UndefinedFurnitureItemTariff(store),
  undefinedFurnitureTrafficPlanTariff: new UndefinedFurnitureTrafficPlanTariff(
    store
  ),
  undefinedTrashTariff: new UndefinedTrashTariff(store),
  undefinedTrashCarTariff: new UndefinedTrashCarTariff(store),
  undefinedMaterialTariff: new UndefinedMaterialTariff(store),
  undefinedAuctionTariff: new UndefinedAuctionTariff(store),
  reportsSettlementDriver: new ReportsSettlementDriver(store),

  // feedback ----------------------------------------------------------------------------------------------------------
  feedback: new Feedback(store),

  // crm ---------------------------------------------------------------------------------------------------------------
  crmFaq: new CrmFaq(store),
  crmContact: new CrmContact(store),
  crmTicket: new CrmTicket(store),
  crmTicketMessage: new CrmTicketMessage(store),
  crmTutorial: new CrmTutorial(store),

  // financial ---------------------------------------------------------------------------------------------------------
  // bonus
  financialBonusCouponType: new FinancialBonusCouponType(store),
  financialBonusGiftCardType: new FinancialBonusGiftCardType(store),
  financialBonusCoupon: new FinancialBonusCoupon(store),
  financialBonusGiftCard: new FinancialBonusGiftCard(store),
  financialBonusCampaign: new FinancialBonusCampaign(store),
  financialBonusPromotion: new FinancialBonusPromotion(store),

  // payment
  financialPayment: new FinancialPayment(store),
  financialOpenBankingPayment: new FinancialOpenBankingPayment(store),

  // tariff
  furnitureTariff: new FurnitureTariff(store),
  furnitureCarTariff: new FurnitureCarTariff(store),
  furnitureEmployeeTariff: new FurnitureEmployeeTariff(store),
  furnitureItemTariff: new FurnitureItemTariff(store),
  furnitureTrafficPlanTariff: new FurnitureTrafficPlanTariff(store),

  financialTariffCar: new FinancialTariffCar(store),
  financialTariffTrafficPlan: new FinancialTariffTrafficPlan(store),
  financialTariffEmployee: new FinancialTariffEmployee(store),
  financialTariffItem: new FinancialTariffItem(store),
  financialTariffExtra: new FinancialTariffExtra(store),
  financialTariffAuction: new FinancialTariffAuction(store),
  financialTariffMaterial: new FinancialTariffMaterial(store),
  financialTariffTrash: new FinancialTariffTrash(store),
  financialTariffTrashCar: new FinancialTariffTrashCar(store),
  financialTariffFreight: new FinancialTariffFreight(store),
  financialTariffFreightAddon: new FinancialTariffFreightAddon(store),
  financialTariffFurnitureAddon: new FinancialTariffFurnitureAddon(store),
  financialTariffFreightCar: new FinancialTariffFreightCar(store),

  // bank-account
  financialBankAccount: new FinancialBankAccount(store),

  // commercial-banking
  financialCommercialBanking: new FinancialCommercialBanking(store),

  // wallet
  financialTransactionCredit: new FinancialTransactionCredit(store),

  // courier ---------------------------------------------------------------------------------------------------------
  courier: new Courier(store),
  courierOperator: new CourierOperator(store),
  courierHolding: new CourierHolding(store),
  courierLicense: new CourierLicense(store),
  branch: new Branch(store),
  courierBlackList: new CourierBlackList(store),
  courierContract: new CourierContract(store),
  courierShift: new CourierShift(store),

  // user --------------------------------------------------------------------------------------------------------------
  customerUser: new CustomerUser(store),
  adminUser: new AdminUser(store),
  userSession: new UserSession(store),
  userAddress: new UserAddress(store),
  userContract: new UserContract(store),
  userLegal: new UserLegal(store),

  // transport ---------------------------------------------------------------------------------------------------------
  transportDriver: new TransportDriver(store),
  transportVehicle: new TransportVehicle(store),
  transportCredential: new TransportCredential(store),
  transportDriverBlackList: new TransportDriverBlackList(store),

  // base-info ---------------------------------------------------------------------------------------------------------
  // car
  baseInfoCarCategory: new BaseInfoCarCategory(store),
  baseInfoCarType: new BaseInfoCarType(store),
  baseInfoCarLoad: new BaseInfoCarLoad(store),
  baseInfoCarBrand: new BaseInfoCarBrand(store),

  // order-properties
  baseInfoOrderPropertiesEmployee: new BaseInfoOrderPropertiesEmployee(store),
  baseInfoOrderPropertiesItemGroup: new BaseInfoOrderPropertiesItemGroup(store),
  baseInfoOrderPropertiesItemCategory: new BaseInfoOrderPropertiesItemCategory(
    store
  ),
  baseInfoOrderPropertiesItemType: new BaseInfoOrderPropertiesItemType(store),
  baseInfoOrderPropertiesLoad: new BaseInfoOrderPropertiesLoad(store),
  baseInfoOrderPropertiesPackageType: new BaseInfoOrderPropertiesPackageType(
    store
  ),
  baseInfoOrderPropertiesPackage: new BaseInfoOrderPropertiesPackage(store),
  baseInfoOrderPropertiesSoil: new BaseInfoOrderPropertiesSoil(store),
  baseInfoOrderPropertiesAddon: new BaseInfoOrderPropertiesAddon(store),
  baseInfoOrderPropertiesLoadCondition:
    new BaseInfoOrderPropertiesLoadCondition(store),

  // reason
  baseInfoReason: new BaseInfoReason(store),

  // organization
  baseInfoOrganization: new BaseInfoOrganization(store),

  // feedback
  baseInfoFeedbackRateCriterion: new BaseInfoFeedbackRateCriterion(store),
  baseInfoFeedbackPointCriterion: new BaseInfoFeedbackPointCriterion(store),

  // club
  baseInfoClubReferrerType: new BaseInfoClubReferrerType(store),

  // crm
  baseInfoCrmFaqCategory: new BaseInfoCrmFaqCategory(store),
  baseInfoCrmDepartment: new BaseInfoCrmDepartment(store),
  baseInfoCrmMedia: new BaseInfoCrmMedia(store),
  baseInfoCrmCategory: new BaseInfoCrmCategory(store),
  baseInfoCrmSubcategory: new BaseInfoCrmSubcategory(store),
  baseInfoCrmSubject: new BaseInfoCrmSubject(store),
  baseInfoCrmContactSubject: new BaseInfoCrmContactSubject(store),

  // financial
  baseInfoFinancialBank: new BaseInfoFinancialBank(store),
  baseInfoFinancialPolicy: new BaseInfoFinancialPolicy(store),

  // courier
  baseInfoCourierExpertise: new BaseInfoCourierExpertise(store),
  baseInfoCourierEquipment: new BaseInfoCourierEquipment(store),
  baseInfoCourierLicenseType: new BaseInfoCourierLicenseType(store),
  baseInfoCourierLicenseCategory: new BaseInfoCourierLicenseCategory(store),

  // user
  baseInfoUserLicenseType: new BaseInfoUserLicenseType(store),
  baseInfoUserGroup: new BaseInfoUserGroup(store),
  baseInfoUserLevel: new BaseInfoUserLevel(store),

  // contract
  baseInfoContractCategory: new BaseInfoContractCategory(store),

  // cms
  baseInfoCmsThemeCategory: new BaseInfoCmsThemeCategory(store),

  // questionnaire
  baseInfoQuestionnaireQuestionCategory:
    new BaseInfoQuestionnaireQuestionCategory(store),

  // geo
  baseInfoGeoCountry: new BaseInfoGeoCountry(store),
  baseInfoGeoProvince: new BaseInfoGeoProvince(store),
  baseInfoGeoCounty: new BaseInfoGeoCounty(store),
  baseInfoGeoCity: new BaseInfoGeoCity(store),
  baseInfoGeoDistrict: new BaseInfoGeoDistrict(store),
  baseInfoGeoTrafficPlan: new BaseInfoGeoTrafficPlan(store),

  // poi
  baseInfoPoi: new BaseInfoPoi(store),
  baseInfoPoiCategory: new BaseInfoPoiCategory(store),

  // unit
  baseInfoUnitCurrency: new BaseInfoUnitCurrency(store),
  baseInfoUnitMeasurement: new BaseInfoUnitMeasurement(store),

  // feature
  baseInfoFeatureSize: new BaseInfoFeatureSize(store),
  baseInfoFeatureColor: new BaseInfoFeatureColor(store),

  // calendar
  baseInfoCalendarHoliday: new BaseInfoCalendarHoliday(store),

  // -------------------------------------------------------------------------------------------------------------------

  appVersion: new AppVersion(store),
  webView: new WebView(store),
  webService: new WebService(store),
  attachment: new Attachment(store),
  bucket: new Bucket(store),
  container: new Container(store),
  files: new Files(store),
  menus: new Menus(store),
  publicUser: new PublicUser(store),
  geoControll: new GeoControll(store),
  manageDriver: new ManageDriver(store),
  realms: new Realms(store),
  securityPermissions: new SecurityPermissions(store),
  roles: new Roles(store),
  geo: new Geo(store),
  publicGeo: new PublicGeo(store),
  urlShortened: new UrlShortened(store),
  calendarTraffic: new CalendarTraffic(store),
  tariffItemLog: new TariffItemLog(store),
  tariffExtraLog: new TariffExtraLog(store),
  tariffCarLog: new TariffCarLog(store),
  tariffEmployeeLog: new TariffEmployeeLog(store),
  tariffAuctionLog: new TariffAuctionLog(store),
  tariffTrafficPlanLog: new TariffTrafficPlanLog(store),
  event: new Event(store),
  enum: new Enum(store),
  log: new Log(store),
  limit: new Limit(store),
  cmsArea: new CmsArea(store),
  timeSheetTrafficPlanTemplate: new TimeSheetTrafficPlanTemplate(store),
  timeSheetCourierPlanTemplate: new TimeSheetCourierPlanTemplate(store),
  systemDictionary: new SystemDictionary(store),
  cmsLanding: new CmsLanding(store),
  systemDictionaryMiss: new SystemDictionaryMiss(store),
  messageNotification: new MessageNotification(store),
  publicMessageNotification: new PublicMessageNotification(store),
  messageSentSms: new MessageSentSms(store),
  messageSentEmail: new MessageSentEmail(store),
  messageSentNotification: new MessageSentNotification(store),
  logs: new Logs(store),
  fileManager: new FileManager(store),
  messageSms: new MessageSms(store),
  messageEmail: new MessageEmail(store),
  messageInternal: new MessageInternal(store),
  messageInternalTemplate: new MessageInternalTemplate(store),
  cmsSplash: new CmsSplash(store),
  systemGatewayOrder: new SystemGatewayOrder(store),
  systemConfig: new SystemConfig(store),
  systemSettingGeneral: new SystemSettingGeneral(store),
  systemSettingMap: new SystemSettingMap(store),
  license: new Licenses(store),
  bulkUpload: new BulkUpload(store),
  postCategory: new PostCategory(store),
  operationParameter: new OperationParameter(store),
  site: new Site(store),
  sitePage: new SitePage(store),
  siteArea: new SiteArea(store),
  siteContact: new SiteContact(store),
  siteFaq: new SiteFaq(store),
  siteFaqCategory: new SiteFaqCategory(store),
  siteLayout: new SiteLayout(store),
  question: new Question(store),
  answer: new Answer(store),
  survey: new Servey(store),
  siteTemplate: new SiteTemplate(store),
  operation: new Operation(store),
  limitLicense: new LimitLicense(store),
  siteThemeCategory: new SiteThemeCategory(store),
  siteTheme: new SiteTheme(store),
  sitePostCategory: new SitePostCategory(store),
  cmsTheme: new CmsTheme(store),
  codeGenerator: new CodeGenerator(store),
  cmsLayout: new CmsLayout(store),
  cmsPage: new CmsPage(store),
  siteLanding: new SiteLanding(store),
  gatewayEmail: new GatewayEmail(store),
  gatewayNotification: new GatewayNotification(store),
  gatewayPayment: new GatewayPayment(store),
  gatewayOpenBanking: new GatewayOpenBanking(store),
  gatewaySms: new GatewaySms(store),
  siteSplash: new SiteSplash(store),
  siteFileManager: new SiteFileManager(store),
  cmsFileManager: new CmsFileManager(store),
  blogPost: new BlogPost(store),
  blogComment: new BlogComment(store),
  blogFileManager: new BlogFileManager(store),
  blogTag: new BlogTag(store),
  blogArea: new BlogArea(store),
  blogPage: new BlogPage(store),
  courierTimeSheet: new CourierTimeSheet(store),
  setting: new Setting(store),

  // Record -----------------------------------------------------------------------------------------------------------
  recordFurnitureFurnitureTariff: new RecordFurnitureFurnitureTariff(store),
  recordFurnitureCar: new RecordFurnitureCar(store),
  recordFurnitureEmployee: new RecordFurnitureEmployee(store),
  recordFurnitureItem: new RecordFurnitureItem(store),
  recordFurnitureTrafficPlan: new RecordFurnitureTrafficPlan(store),
  recordTrashTariff: new RecordTrashTariff(store),
  recordTrashCar: new RecordTrashCar(store),
  recordTransportVehicle: new RecordTransportVehicle(store),
  recordTransportDriver: new RecordTransportDriver(store),
  recordUserContract: new RecordUserContract(store),

  // Transaction -----------------------------------------------------------------------------------------------------------
  transactionOrder: new TransactionOrder(store),

  // Support -----------------------------------------------------------------------------------------------------------
  supportedCar: new SupportedCar(store),
  supportedEmployee: new SupportedEmployee(store),
  supportedItem: new SupportedItem(store),

  // external apis
  ext_neshan: new Neshan(store),

  // External system
  baraneh: new Baraneh(store)
})
